module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_7042.8ed81351.png";